(function(){
  const root=document.documentElement;
  root.classList.add('fh-theme');
  const reduce=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-fh-hero-slideshow]').forEach(section=>{
    const slides=[...section.querySelectorAll('.fh-hero__slide')];
    const dots=[...section.querySelectorAll('[data-fh-slide-dot]')];
    if(slides.length<2) return;
    let active=0, timer;
    const show=(i)=>{active=(i+slides.length)%slides.length;slides.forEach((s,idx)=>s.classList.toggle('is-active',idx===active));dots.forEach((d,idx)=>d.classList.toggle('is-active',idx===active));};
    const stop=()=>{ if(timer) window.clearInterval(timer); };
    const start=()=>{ if(reduce) return; stop(); timer=window.setInterval(()=>show(active+1),6500); };
    dots.forEach((dot,i)=>dot.addEventListener('click',()=>{show(i);start();}));
    section.addEventListener('mouseenter',stop);section.addEventListener('mouseleave',start);start();
  });

  if(!reduce && window.innerWidth>989){
    const parallaxEls=[...document.querySelectorAll('[data-fh-parallax]')];
    const footerParallax=[];
    let ticking=false;
    function update(){
      const y=window.scrollY||0;
      parallaxEls.forEach(el=>{const speed=parseFloat(el.dataset.fhParallax||'0.035');el.style.transform='translate3d(0,'+(y*speed)+'px,0)';});
      footerParallax.forEach(el=>{
        const rect=el.getBoundingClientRect();
        const progress=(window.innerHeight-rect.top)/(window.innerHeight+rect.height);
        const clamped=Math.max(0,Math.min(1,progress));
        const offset=(clamped-.5)*54;
        el.style.setProperty('--fh-footer-parallax', offset.toFixed(2)+'px');
      });
      ticking=false;
    }
    if(parallaxEls.length){window.addEventListener('scroll',()=>{if(!ticking){requestAnimationFrame(update);ticking=true;}},{passive:true}); update();}
  }

  if(!reduce && 'IntersectionObserver' in window){
    const els=[...document.querySelectorAll('.fh-reveal,.fh-tile,.fh-product-card,.fh-accessory,.fh-featured-panel,.fh-community__shot,.fh-section__head')];
    const obs=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('fh-revealed');obs.unobserve(entry.target);}});},{threshold:.12,rootMargin:'0px 0px -40px 0px'});
    els.forEach(el=>obs.observe(el));
  }

  document.querySelectorAll('[data-fh-back-top]').forEach(btn=>btn.addEventListener('click',()=>window.scrollTo({top:0,behavior:reduce?'auto':'smooth'})));
})();
